import config from 'config'

import { Link } from 'tools/Link'

import { BetaBar } from '../Widgets'

function Footer(props) {
  return (
    <>
      <BetaBar />
      <div className="base-navbar bt b--navbar" id="footer">
        <div className="flex-center flex-column mt5 pa2 b mb4">
          <div className="flex-center gh2">
            <div className="mb1">
              <Link to="/terms/tos/">Terms of Use</Link>
            </div>
            <div className="mb1 gray">◆</div>
            <div className="mb1">
              <Link to="/terms/privacy/">Privacy Policy</Link>
            </div>
          </div>
          <div className="flex-center gray mb4 mt4 f2">
            <Link to="/terms/ip/" className="flex-items f2">
              <img
                src={config.logo.small}
                alt={config.name}
                style={{ height: '1rem' }}
                className="mr2 logo"
              />
              {config.name} &copy; {new Date().getFullYear()}, &trade; Protos, LLC
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
